import { InheritanceStatus, PromptInterface } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant, Input } from "@swivl-mono/ui";
import React from "react";
import ReactMarkdown from "react-markdown";

import { TagInput } from "../../../../Components/TagInput/TagInput";
import { AIModel } from "../../../../Models/AI/AI.Model";
import { Member } from "../../../../Models/Member/Member.Current";

interface Props {
  prompt: PromptInterface;
}

export const CustomPrompt: React.FC<Props> = (props) => {
  const [prompt, setPrompt] = React.useState<PromptInterface>(props.prompt);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);
  const onMessageChange = (e) => {
    setIsDirty(true);
    let _prompt = { ...prompt };
    _prompt[e.target.name] = e.target.value;
    setPrompt(_prompt);
  };

  if (prompt.inheritance === InheritanceStatus.IS_PARENT) {
    return (
      <div className="CustomPrompt">
        <label className="mb-3">{prompt.name}</label>
        <div className="text">
          <ReactMarkdown>{prompt.text}</ReactMarkdown>
        </div>
        <div className="buttons">
          <Button
            color={ButtonColor.YELLOW}
            loading={isSaving}
            onClick={() => {
              setIsSaving(true);
              let _prompt = { ...prompt };
              _prompt.orgId = Member.orgId;
              AIModel.savePrompt(_prompt);
            }}
          >
            Customize
          </Button>
          <div className="slug">{prompt.slug}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="CustomPrompt flex flex-col gap-2">
      <Input label="Name" value={prompt.name} name="name" onChange={onMessageChange} placeholder="Name..." />
      <TagInput label="Prompt" placeholder="Prompt..." value={prompt.text} onChange={onMessageChange} name="text" />
      <div className="buttons">
        <Button
          variant={ButtonVariant.GHOST}
          loading={isSaving}
          onClick={async () => {
            if (window.confirm("Are you sure you want to delete this prompt?")) {
              setIsSaving(true);
              await AIModel.deletePrompt(prompt);
            }
          }}
        >
          Delete
        </Button>

        {isDirty && (
          <Button
            color={ButtonColor.YELLOW}
            loading={isSaving}
            onClick={async () => {
              setIsSaving(true);
              await AIModel.savePrompt(prompt);
              setIsDirty(false);
            }}
          >
            Save
          </Button>
        )}
        <div className="slug">{Member.isSwivlStaff && prompt.slug}</div>
      </div>
    </div>
  );
};
